module.exports = __webpack_public_path__ + "static/PcWithDash-ani-css-9ae9ec26bd066958a54b859e4d777875.svg";